import { useState } from "react";
// 1. IMPORTAMOS useSearchParams
import { useNavigate, useSearchParams } from "react-router-dom";
import { useWallet } from "../context/WalletContext";
import "../styles/moxWallet.css";
import "../styles/general.css";
import { loadEncryptedWallet } from "../utils/secureStorage";
import { decryptMnemonic } from "../utils/crypto";
import algosdk from "algosdk";

function isStrongPassword(pw: string): boolean {
 return /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(pw);
}

interface LoginProps {
 setMessage: (msg: string) => void;
}

const Login: React.FC<LoginProps> = ({ setMessage }) => {
 const [username, setUsername] = useState("");
 const [password, setPassword] = useState("");
 const { setAccount } = useWallet();
 const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirect_to') || '/home';


 const handleLogin = async () => {
  if (!isStrongPassword(password)) {
   return setMessage("La contraseña debe tener al menos 8 caracteres, incluyendo letras, números y un símbolo.");
  }

  try {
   const encrypted = await loadEncryptedWallet(username);
   if (!encrypted) {
    return setMessage("⚠️ Cuenta no encontrada");
   }

   const mnemonic = await decryptMnemonic(encrypted, password);
   if (!mnemonic || mnemonic.split(" ").length !== 25) {
    throw new Error("Mnemonic inválido");
   }

   const acc = algosdk.mnemonicToSecretKey(mnemonic);
   setAccount(acc, false, username);
   setMessage("✅ Sesión iniciada");

      console.log(`Login exitoso. Redirigiendo a: ${redirectTo}`);
   navigate(redirectTo, { replace: true }); 

  } catch (error: any) {
   console.error("Error al desencriptar:", error);
   if (error.message?.includes("decrypt")) {
    setMessage("❌ Contraseña incorrecta");
   } else {
    setMessage("❌ Contraseña incorrecta o datos corruptos");
   }
  }
 };

 return (
  <div className="modal-container">
   <div className="wallet-container">
   <form
 onSubmit={(e) => {
  e.preventDefault(); 
  handleLogin();   
 }}
>
 <h2 className="text-lg font-bold">Iniciar sesión</h2>

 <input
  className="wallet-input"
  name="username"       
  placeholder="Usuario"
  value={username}
  onChange={(e) => setUsername(e.target.value)}
  autoComplete="username"   
 />

 <input
  className="wallet-input"
  type="password"
  name="password"       
  placeholder="Contraseña"
  value={password}
  onChange={(e) => setPassword(e.target.value)}
  autoComplete="current-password"
 />

 <button type="submit" className="wallet-button">
  Conectar Mox App
 </button>
</form>
    <button
     className="wallet-button"
     onClick={() => navigate("/register")}
    >
     Crear nueva cuenta
    </button>
    <button className="button-exit" onClick={() => navigate("/home")}>
     Iniciar sin Cuenta
    </button>
   </div>
  </div>
 );
};

export default Login;